'use client';
import * as React from 'react';

import H2 from '@/components/atoms/Typography/H2';
import Section from '@/components/layout/Section';

import OrderedItemsList from './components/OrderedItemsList';
import type { OrderedItemsSectionConfigType } from './OrderedItemsSection.types';

export interface OrderedItemsSectionProps
    extends React.HTMLAttributes<HTMLDivElement> {
    config: OrderedItemsSectionConfigType;
}

const OrderedItemsSection = React.forwardRef<
    HTMLDivElement,
    OrderedItemsSectionProps
>(({ config, ...props }, ref) => (
    <Section
        ref={ref}
        {...props}
    >
        {config.title ? (
            <H2 className="mb-8 text-center">{config.title}</H2>
        ) : null}

        <OrderedItemsList itemList={config.itemList} />
    </Section>
));

export default OrderedItemsSection;
